export enum RuleActionEnum {
    NotifyMailCenter = "Notify Mail Center",
    NotifyIntDistCenter = "Notify Int Dist Center",
    AutoCreate = "Auto Create",
}

export const RuleActionEnumList: {
    key: string;
    value: string;
}[] = Object.entries(RuleActionEnum)
    .map(([key, value]) => ({ key, value }));


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/rules/directives/rulesDialog/models/ruleActionEnum.ts
 **/